import { render, staticRenderFns } from "./RecommendedAppsPreview.vue?vue&type=template&id=e2a6efa2&scoped=true"
import script from "./RecommendedAppsPreview.vue?vue&type=script&lang=js"
export * from "./RecommendedAppsPreview.vue?vue&type=script&lang=js"
import style0 from "./RecommendedAppsPreview.vue?vue&type=style&index=0&id=e2a6efa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a6efa2",
  null
  
)

export default component.exports